import RequestState from 'Enums/RequestState'

export const INITIAL_STATE = {
  loginLoading: false,
  resetPasswordRequestState: RequestState.UNINITIALIZED,
  resetPassVerificationRequestState: RequestState.UNINITIALIZED,
  resetPassEmailID: '',
  token: null,
  refreshToken: null,
  operator: null,
  operatorUser: null,
  fetchOperatorUserRequestState: RequestState.UNINITIALIZED,
  operatorUserLoading: false,
  requires2FA: false,
  requires2FASetup: false,
  challengeId: null,
  otpauthUrl: null,
  manualKey: null,
  setupComplete: false,
}
